export const PAGINA_INICIO = 0;
export const PAGINA_UNO = 1;